import $ from 'jquery';

$.fn.alertBoxes = function() {
  return this.each(function() {
    const that = $(this);
    $('.close').click(function(e) {
      e.preventDefault();
      $(this)
        .closest(that)
        .slideUp();
    });
  });
};
